module.exports = __webpack_public_path__ + "img/client-no-logo.7bf13795.png";